import React from 'react';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import { PreQualificationPopUpHelpers } from 'areas/shared/helpers';

class PreQualificationInfoPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            prequalificationInfo: props.prequalificationInfo
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            prequalificationInfo: nextProps.prequalificationInfo
        });
    }

    close = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose();
        });
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Pre-Qualification Information – <small>Details</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                {this.state.prequalificationInfo.questionnaire == null ?
                                    <React.Fragment>
                                        <Row>
                                            <Col md={12}>
                                                <h5><em>No Pre-Qualification information available</em></h5>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                :
                                <React.Fragment>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={5}>
                                            <p>
                                                Pre-Qualification status
                                                <br />
                                                <b style={{fontSize:"14pt"}}>Complete</b>
                                            </p>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col md={2}></Col>
                                        <Col md={8}>
											{this.state.prequalificationInfo.questionnaire &&
												<React.Fragment>
													<table className="table table-bordered table-condensed">
														<thead>
															<tr style={{backgroundColor:"#D3D1D0"}}>
																<th colSpan="2">
																	Veteran Status Prequalification
																</th>
															</tr>
														</thead>
														<tbody>
															{this.state.prequalificationInfo.questionnaire.questionCategories.map((category, index) =>
																<React.Fragment>
																	{category.questions.map((question) => 
																		<tr key={question.id}>
																			<td>
																				{question.text}
																			</td>
																			<td width="5%">
																				<b>{question.answer ? "Yes" : "No"}</b>
																			</td>
																		</tr>
																	)}
																</React.Fragment>
															)}
														</tbody>
													</table>
												</React.Fragment>
											}
											{PreQualificationPopUpHelpers.renderGrossRevenueTable(this.state)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={2}>
											{PreQualificationPopUpHelpers.renderDownloadButton(this.props.certificationId, this.state.prequalificationInfo, this.close)}
                                        </Col>
                                    </Row>
                                </React.Fragment>}
                            </Col>
                        </Row>
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default PreQualificationInfoPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/companyInfo/PreQualificationInfoPopUp.js